import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {connect} from "react-redux";
import { useForm } from "react-hook-form";


// components
import ChefLangs from "./_langs";
import SelectGeneric from "../../../components/select/selectGeneric";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, INTERNATIONAL, REQUIRED
} from "../../../components/i18n/i18n";
import {FL_CODE, FL_IMAGE, FL_NAME, FL_STATUS, FL_VIDEO_URL} from "../../../components/i18n/formLabels";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {PH_IMAGE} from "../../../components/i18n/placeHolders";

// services & providers
import {placeProvider} from "../../../providers/placeProvider";
import {chefService} from "../../../jwt/_services/ayb/chefService";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

// actions
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";

const ChefForm = props => {
    const { editMode, domainObject } = props.formProps;
    const { udn, app, category } = props.mainProps;
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status !== undefined ? domainObject?.status : true);
    const [placeId, setPlaceId] = useState(editMode ? props.item?.place?.id : null);

    const [langs, setLangs] = useState(domainObject?.langs || []);

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `${udn?.code.toLowerCase()}_chef_` + getCurrentDateForCodeField()),
            showOrder : domainObject?.showOrder,
            image : domainObject?.image,
            name : domainObject?.name,
            videoUrl : domainObject?.videoUrl
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  {  id : app?.fbDataBase?.id },
            item: {
                ...data,
                status      : status,
                udn   	    : { id : udn?.id },
                place       : { id : placeId },
                langs: langs,
            }
        };

        // console.log(dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(chefService, id, dataRequest)
        } else {
            genericActions.save(chefService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }


    return (<>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input type="text"
                                       name="code"
                                       placeholder="Codigo"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div> }
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_NAME}</Label>
                                <Input type="text"
                                       name="name"
                                       placeholder="Nombre"
                                       innerRef={register}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                                { errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div> }
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_IMAGE}</Label>
                                <Input
                                    type="text"
                                    name="image"
                                    placeholder={PH_IMAGE}
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{FL_VIDEO_URL}</Label>
                                <Input type="text"
                                       name="videoUrl"
                                       placeholder="url"
                                       innerRef={register}
                                       className={(errors.videoUrl ? ' is-invalid' : '')}
                                />
                                { errors.videoUrl && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div> }
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Restaurante</Label>
                                <SelectGeneric
                                    initialValue={ placeId }
                                    setExternalValue = { value => setPlaceId( value ) }
                                    isDisabled = { false }
                                    provider = { placeProvider }
                                    customFilter={{ item : {categoryCodes : category, udn : {id : udn.id}}} }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{ INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <ChefLangs
                            langs={langs}
                            setLangs={setLangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showHistoryModal && <LogHistoryModal
                ref={ modalHistoryRef }
                item={ domainObject }
            />
        }
    </>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ChefForm)